
<template>
	<c-dialog ref="dialog" width="500" height="200" @resolve="editHandle">
		<c-form ref="taskForm" unit-width="100%">
			<c-form-item label="设置为" required>
				<c-select name="priority" :options="prioritySelectDic"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	computed: {
		// 获取dictName选项数据
		...mapState(['prioritySelectDic'])
	},
	data() {
		return {
			task_id: 0,
			task_ids: []
		}
	},
	
	// 监听器
	watch: {
		
	},
	
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data) {
			this.$refs.taskForm.clear();
			this.task_id = data.id;
			this.task_ids = [];
			this.getDetail();
			this.$refs.dialog.open({
				title: '任务优先级'
			});
		},
		
		/************打开批量编辑弹窗**************/
		batchOpen(ids) {
			this.$refs.taskForm.clear();
			this.task_id = 0;
			this.task_ids = ids;
			this.$refs.dialog.open({
				title: '批量调整任务优先级'
			});
		},

		/*******搜索任务详情*******************/
		getDetail() {
			this.request({
				url:'/task/detail',
				data: {
					id: this.task_id
				},
				loading: true,
				success: data => {
					//工单基本信息
					this.$refs.taskForm.set(data);
				}
			});
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			
			this.$refs.taskForm.submit({
				url: this.task_ids.length == 0?'/task/editPriority':'/task/editPriority/batch',
				rule: {
					priority: '请选择优先级'
				},
			    dataFormatter: data => {
					data.id = this.task_id||0;
					data.ids = this.task_ids;
					return data;
				},
				success: (data, res) => {
					next();
					let Mtype = 'success';
					let message = '调整优先级成功';
					if(this.task_ids.length > 0){
						message = '成功' + res.success_count + '条';
						if(res.fail_count > 0 && res.success_count > 0){
							Mtype = 'warn';
							message += '，失败'+res.fail_count+'条';
						}else if(res.fail_count > 0 && res.success_count == 0){
							Mtype = 'fail'
							message += '，失败'+res.fail_count+'条';
						}else{
							message = '成功调整优先级' + res.success_count + '条';
						}
					}
					this.$message({
						message: message,  // 提示内容,
						type: Mtype
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>